export default __webpack_public_path__ + "5a12f48a133183cda181a921d35c945d.svg";